import { Component } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { BaseQuantityselectionComponent } from './base-quantityselection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-quantityselection-compact',
    imports: [
    NgClass,
    NgTemplateOutlet,
    TranslatePipe
],
    templateUrl: './quantityselection-compact.component.html',
    styleUrl: './quantityselection-compact.component.scss'
})
export class QuantityselectionCompactComponent extends BaseQuantityselectionComponent {

  constructor() {
    super()
  }
}
